module.exports = __webpack_public_path__ + "static/media/46486021_522626071553544_2253869575605059584_n.74b0848d.jpg";